import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { installTranslationSafeDom } from "./lib/translationSafeDom";

// 브라우저 번역이 텍스트 노드를 바꿔 놓아도 흰 화면이 되지 않게 첫 렌더 전에 설치한다 (CLAUDE.md Phase 8)
installTranslationSafeDom();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
